export const actionKey = '@@tierConsumer';
export const tierConsumerReduxKey = '@@tierConsumer';
